<div class="container">
  <div class="header">
    Hay una nueva actualizacion disponible
  </div>
  <ion-button (click)="update()" class="btn-download" >
    Actualizar
  </ion-button>
</div>